<section>
    <h2 class="m-0 text-xl font-semibold">Detalhe da Estrutura Organizacional</h2>
    @if (idEstrutura) {
        <p class="mt-3 mb-0 text-color-secondary">Estrutura selecionada: {{ idEstrutura }}</p>
    } @else {
        <p class="mt-3 mb-0 text-color-secondary">Nenhuma estrutura foi informada.</p>
    }
</section>
